import Image from "next/image";
import React from "react";
import { resolveImageSource } from "@repo/ui/helpers";
import sharkImg from "@repo/ui/resources/avatars/kinsa/profile_icon_shark_large.png";
import type { AvatarAssetProps } from "../../avatar/brand-config";

const SharkAvatar: React.FC<AvatarAssetProps> = ({
  width = 80,
  height = 80,
  className = "",
}) => (
  <div style={{ width, height }} className={className}>
    <Image
      src={resolveImageSource(sharkImg)}
      alt="Shark Avatar"
      width={width}
      height={height}
      priority
    />
  </div>
);

export default SharkAvatar;
